import { render, staticRenderFns } from "./PlacementsSingleSettingsCard.vue?vue&type=template&id=53222c54&"
import script from "./PlacementsSingleSettingsCard.vue?vue&type=script&lang=js&"
export * from "./PlacementsSingleSettingsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports